export default class GeneralFilter {
  constructor () {
    this.setFilterInitialValue()
  }

  setFilterInitialValue () {
    this.search = ''
  }
}
